/**
 * Type and section classes shared by the landing sections, taken from the
 * Figma frame (file `Resale`, node 11485-21988).
 *
 * The type steps are arbitrary values because the Atoms ramp has no entry for
 * them: the display sizes bracket the 72px hero (65 / 92), and header-lg is
 * 45px against the section headings' 48px.
 */
export const HERO_HEADING =
  'font-medium text-[40px] leading-[40px] tracking-[-2px] md:text-[56px] md:leading-[56px] lg:text-[65px] lg:leading-[65px] lg:tracking-[-2.21px]';
export const SECTION_HEADING =
  'font-medium text-[32px] leading-[36px] tracking-[-1.6px] lg:text-[48px] lg:leading-[48px] lg:tracking-[-2.4px]';
export const BODY_COPY = 'text-[20px] leading-[26px] tracking-[-1px] text-od-content-secondary';

export const SECTION = 'w-full justify-center px-6 lg:px-10';
export const SECTION_INNER = 'w-full max-w-[1207px] flex-col';
